import { i18next } from '@frontend/i18n';

export const validateCallerLabel = ({ value }: { value: string }) => {
  // Block ONLY these characters: | : @ ^ < > " =
  const invalidPattern = /[|:^@<>"=]/;

  if (invalidPattern.test(value)) {
    return i18next.t('Invalid characters: | : @ ^ < > " =', { ns: 'phone' });
  }
  if (value.length > 26) {
    return i18next.t('{{count}}/26 characters. Shorten label to 26 characters.', { count: value.length, ns: 'phone' });
  }
  return '';
};

export const validateAudioFileName = ({ value }: { value: string }) => {
  // Allow ONLY: letters, numbers, underscore, hyphen, and spaces
  const validPattern = /^[A-Za-z0-9 _-]+$/;

  if (!validPattern.test(value)) {
    return i18next.t('Only letters, numbers, underscore (_), hyphen (-), and spaces are allowed.', { ns: 'phone' });
  }

  if (value.length > 26) {
    return i18next.t('{{count}}/26 characters. Shorten label to 26 characters.', { count: value.length, ns: 'phone' });
  }

  return '';
};
